import { Component, Input } from '@angular/core';
import { ProductClass } from '../../models/product-class.model';

@Component({
    selector: 'app-product-class-form',
    templateUrl: './product-class-form.component.html',
    styleUrls: ['./product-class-form.component.scss'],
    standalone: false
})
export class ProductClassFormComponent {

  @Input()
  productClass: ProductClass;
}
